export default {
    "de": {
        "magento1connector": {
            "shop": {
                "header": "Magento 1 Shop Connector",
                "department": "Abteilung",
                "active": "Aktiv",
                "created": "Erstellt",
                "config": "Konfiguration",
                "delete": "Löschen",
                "edit": "Bearbeiten",
                "url": "Host Url",
                "api_key": "API-Key",
                "username": "Benutzername"
            },
            "label": {
                "edit": "Magento 1 Verbindung bearbeiten",
                "create": "Magento 1 Verbindung erstellen"
            },
            "confirmDelete": "Sind Sie sicher, dass sie die Konfiguration löschen wollen? Dies lässt sich nicht rückgängig machen!"
        }
    }
}
